import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import Loading from "../../components/extras/Loading";

class LoadingModal extends Component {
    render() {
        return (
            <Modal basic size='small' open={this.props.show} dimmer='inverted'>
                <Modal.Content>
                    <Loading message={this.props.message} />
                </Modal.Content>
            </Modal>
        );
    }
}

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/components/extras/LoadingModal.js